// extracted by mini-css-extract-plugin
export default {"pageLayout":"PageLayout_pageLayout__mcCcK","contentBox":"PageLayout_contentBox__RoNN3","pageContent":"PageLayout_pageContent__ZEym7"};